module.exports = __webpack_public_path__ + "img/login-vencedoresdetarqui.f2f53248.svg";